import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-6a2 2 0 1 1 4 0v6","key":"svg-0"}],["path",{"d":"M10 13h4","key":"svg-1"}]]

const IconLetterASmall = createReactComponent('outline', 'letter-a-small', 'LetterASmall', __iconNode);

export default IconLetterASmall;